import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Audio functions
import { createAudioMeter } from './VolumeMeter';

const Microphone = observer(class Microphone extends React.Component {
  componentDidMount() {
    this.initMicrophone();
    this.props.button.disabled = true
  }

  componentWillUnmount() {
    this.killMicrophone();
  }

  componentDidUpdate(prevProps) {
    const { microphone } = this.props;

    // Change webcam
    if(microphone !== prevProps.microphone) {
      this.initMicrophone()
    }
  }

  killMicrophone() {
    // Kill the camera stream on unmount
    if(this.stream) {
      this.stream.getTracks().forEach(track => {
        track.stop();
      });
    }
  }

  initMicrophone() {
    const _this = this;
    const { microphone } = this.props;

    this.killMicrophone();

    const constraints = {
      audio: true
    };

    if(microphone) {
      constraints.audio = {
        deviceId: microphone
      };
    }

    navigator.mediaDevices.getUserMedia(constraints)
      .then(media => {
        _this.stream = media;

        _this.visualize();

        // Stream the media to the video element
        // const audioEl = document.querySelector('.microphone__stream');
        // audioEl.srcObject = media;
        // audioEl.onloadedmetadata = function(e) {
        //   audioEl.play();
        // };
      })
      .catch(error => {
        console.error(error);
      });
  }

  visualize() {
    const audioCtx = new (window.AudioContext)();
    const src = audioCtx.createMediaStreamSource(this.stream);
    const meter = createAudioMeter(audioCtx);

    src.connect(meter);

    const canvas = document.querySelector('.microphone__visualizer');
    const canvasCtx = canvas.getContext('2d');
    const width = canvas.width;
    const height = canvas.height;

    const volumeCheck = setInterval(() => {
      const audioLevel = meter.volume * 100;
      const hasAudio = audioLevel >= 1;

      if(hasAudio) {
        this.props.onAudioDetected();
        clearInterval(volumeCheck);
      }

    }, 100);

    draw();

    function draw() {
      canvasCtx.clearRect(0, 0, width, height);
      canvasCtx.fillStyle = 'lime';

      canvasCtx.fillRect(0, 0, width, meter.volume * height * 5);

      requestAnimationFrame(draw);
    }
  }

  render() {
    return (
      <div className="microphone">
        <audio className="microphone__stream" muted="true"></audio>
        <canvas className="microphone__visualizer"></canvas>
      </div>
    );
  }
})

export default translate('Microphone')(Microphone);


// WEBPACK FOOTER //
// ./src/app/components/UserMedia/Microphone.js